import React from 'react';
import { inp, lbl, noAutofill } from './shared';

function Section({ title, children }) {
  const content = React.Children.toArray(children).filter(Boolean);
  if (!content.length) return null;
  return (
    <div style={{ marginBottom: 22 }}>
      <div style={sectionTitle}>{title}</div>
      {content}
    </div>
  );
}

function Field({ label, value }) {
  if (!value && value !== 0) return null;
  return (
    <div style={field}>
      <span style={{ color: '#7a99b8' }}>{label}</span>
      <strong style={{ color: '#1a3364', textAlign: 'right' }}>{value}</strong>
    </div>
  );
}

function yn(value) {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  return '';
}

const INCOME_RANGE_LABELS = {
  'under-100-fpl': 'Under 100% FPL',
  '100-150-fpl': '100% to 150% FPL',
  '150-200-fpl': '150% to 200% FPL',
  '200-250-fpl': '200% to 250% FPL',
  '250-400-fpl': '250% to 400% FPL',
  'over-400-fpl': 'Over 400% FPL',
  unsure: 'I am not sure',
};

export default function Review({ data, onChange }) {
  const fullName = [data.firstName, data.middleName, data.lastName].filter(Boolean).join(' ');
  const address = [data.address, data.address2, data.city, data.county, data.state, data.zip].filter(Boolean).join(', ');
  const mailing = data.mailingIsSameAsPhysical !== false ? '' : [data.mailingAddress, data.mailingAddress2, data.mailingCity, data.mailingState, data.mailingZip].filter(Boolean).join(', ');
  const interests = (data.insuranceInterests || []).filter(Boolean).join(', ');
  const members = (data.householdMembers || []).filter(member => member.firstName || member.lastName);
  const providers = (data.preferredProviders || []).filter(Boolean);
  const doctors = (data.doctors || []).filter(doctor => doctor.name || doctor.location || doctor.npi);
  const prescriptions = (data.prescriptions || []).filter(rx => rx.name || rx.strength || rx.frequency || rx.instructions);

  return (
    <div>
      <Section title="Contact">
        <Field label="Name" value={fullName} />
        <Field label="Nickname" value={data.nickname} />
        <Field label="Email" value={data.email} />
        <Field label="Phone" value={data.phone} />
        <Field label="Address" value={address} />
        <Field label="Mailing Address" value={mailing} />
      </Section>

      <Section title="Coverage">
        <Field label="Interests" value={interests} />
        <Field label="Currently Insured" value={yn(data.hasCurrentInsurance)} />
        <Field label="Requested Start Date" value={data.requestedStartDate} />
        <Field label="Coverage For" value={data.coverageFor === 'Other' ? data.coverageForOther : data.coverageFor} />
        <Field label="Household Size" value={data.coverageFor === 'Myself' ? '1' : data.householdSize} />
        <Field label="Household Income Range" value={INCOME_RANGE_LABELS[data.householdIncomeRange] || data.householdIncomeRange || data.householdIncome} />
      </Section>

      {members.length > 0 && (
        <Section title={`Household (${members.length})`}>
          {members.map((member, index) => (
            <div key={index} style={item}>
              <strong>{[member.firstName, member.lastName].filter(Boolean).join(' ')}</strong>
              <span>{[member.relationship, member.dob, member.gender, member.tobacco && `Tobacco: ${member.tobacco}`, member.pregnant && `Pregnant: ${member.pregnant}`].filter(Boolean).join(' | ')}</span>
            </div>
          ))}
        </Section>
      )}

      <Section title="Providers">
        {providers.map((provider, index) => <Field key={index} label={`Preferred Provider ${index + 1}`} value={provider} />)}
        {doctors.map((doctor, index) => <Field key={index} label={`Doctor ${index + 1}`} value={[doctor.name, doctor.specialty, doctor.city, doctor.state].filter(Boolean).join(' - ')} />)}
      </Section>

      {prescriptions.length > 0 && (
        <Section title={`Prescriptions (${prescriptions.length})`}>
          {prescriptions.map((rx, index) => <Field key={index} label={`Prescription ${index + 1}`} value={[rx.name, rx.strength, rx.frequency || rx.instructions].filter(Boolean).join(' - ')} />)}
        </Section>
      )}

      <Section title="Consent">
        <Field label="Electronic Signature" value={data.consentSignature} />
        <Field label="Consent Accepted" value={data.consentAgreed ? 'Yes' : ''} />
      </Section>

      <div style={{ borderTop: '1.5px solid #dbeef8', paddingTop: 18 }}>
        <label style={lbl}>Comments</label>
        <textarea style={{ ...inp, minHeight: 110, resize: 'vertical' }} value={data.comments} onChange={e => onChange('comments', e.target.value)} {...noAutofill('comments')} />
      </div>
    </div>
  );
}

const sectionTitle = { borderBottom: '1.5px solid #dbeef8', paddingBottom: 8, marginBottom: 10, color: '#1a3364', fontSize: 13, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.06em' };
const field = { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16, marginBottom: 8, fontSize: 14 };
const item = { display: 'grid', gap: 4, background: '#f4f8fc', borderRadius: 8, padding: 12, marginBottom: 8, color: '#4a6288' };
